export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'life', name: '生活服务', icon: 'ri-home-heart-line', description: '日常生活所需的各类服务平台，涵盖天气、快递、挂号、缴费等实用工具' },
  { slug: 'entertainment', name: '娱乐休闲', icon: 'ri-movie-line', description: '影视、音乐、游戏、动漫等娱乐资源，放松身心的好去处' },
  { slug: 'tools', name: '工具资源', icon: 'ri-tools-line', description: '在线工具、格式转换、图片处理、文件管理等效率工具合集' },
  { slug: 'education', name: '学习教育', icon: 'ri-book-open-line', description: '在线课程、知识百科、语言学习、学术资源等学习平台' },
  { slug: 'news', name: '新闻资讯', icon: 'ri-newspaper-line', description: '国内外新闻、行业动态、科技资讯等实时信息平台' },
  { slug: 'tech', name: '科技数码', icon: 'ri-smartphone-line', description: '数码产品评测、技术教程、开发者社区等科技前沿阵地' },
  { slug: 'shopping', name: '购物消费', icon: 'ri-shopping-bag-3-line', description: '电商平台、团购优惠、二手交易等在线购物渠道' },
  { slug: 'finance', name: '金融理财', icon: 'ri-bank-line', description: '银行服务、股票基金、保险理财等金融信息平台' },
  { slug: 'social', name: '社交社区', icon: 'ri-group-line', description: '社交网络、论坛社区、兴趣小组等在线交流空间' },
  { slug: 'media', name: '影音图像', icon: 'ri-image-line', description: '图片素材、视频平台、设计资源、音乐电台等多媒体资源' },
];